const endpoints = {
  listRemunerationsBonus: (): string => `remuneration/bonus`,
};

export default endpoints;
